export const preventDefaultAndStopPropagation = (e: React.DragEvent<HTMLDivElement>) => {
	e.preventDefault();
	e.stopPropagation();
};
